const devBaseURL = "http://8.131.93.145:54010";
const proBaseURL = "https://hekou-nurse-api.xinyilu.cn";
export const BASE_URL = process.env.NODE_ENV === 'development' ? devBaseURL : proBaseURL;

export const TIMEOUT = 10000;
